<template>
  <div class="platform-view">
    <section class="site-hero platform-hero">
      <div class="site-hero__inner">
        <h1>平台入口</h1>
      </div>
    </section>

    <section class="page-section content-section">
      <div class="page-head">
        <div><h2>平台列表</h2></div>
      </div>
      <div class="platform-grid">
        <article
          v-for="item in platformEntries"
          :key="item.key || item.title"
          class="platform-card panel-card"
          tabindex="0"
          @click="openPlatform(item)"
          @keyup.enter="openPlatform(item)"
        >
          <div class="platform-figure">
            <img :src="item.image || fallbackImage" :alt="item.title">
          </div>
          <div class="platform-body">
            <h3>{{ item.title }}</h3>
            <!-- <p>{{ item.description }}</p> -->
            <span class="platform-link">进入平台<i class="el-icon-top-right"></i></span>
          </div>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
import { getSitePage } from "@/api/website";

export default {
  name: "PlatformEntriesView",
  data() {
    return {
      fallbackImage: "/assets/eut.png",
      platformEntries: []
    };
  },
  created() {
    getSitePage("platformEntrance").then((res) => {
      const data = res.data || {};
      this.platformEntries = data.platformEntries || [];
    });
  },
  methods: {
    openPlatform(item) {
      const link = this.normalizeExternalUrl(item && item.link);
      if (!link) {
        return;
      }
      window.open(link, "_blank", "noopener,noreferrer");
    },
    normalizeExternalUrl(url) {
      const value = String(url || "").trim();
      if (!value) {
        return "";
      }
      if (/^(https?:)?\/\//i.test(value)) {
        return value;
      }
      return `https://${value}`;
    }
  }
};
</script>

<style lang="less" scoped>
.platform-hero {
  min-height: 46vh;
  background:
    linear-gradient(90deg, rgba(3, 23, 50, 0.94) 0%, rgba(7, 55, 105, 0.76) 48%, rgba(12, 83, 146, 0.36) 100%),
    url("/assets/banner.png") center / cover no-repeat;
}

.content-section {
  background: var(--soft-blue);
}

.platform-grid {
  width: min(1280px, 100%);
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
}

.platform-card {
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.platform-card:hover,
.platform-card:focus {
  transform: translateY(-4px);
  border-color: rgba(32, 184, 218, 0.5);
  box-shadow: 0 18px 38px rgba(14, 70, 128, 0.14);
  outline: none;
}

.platform-figure {
  display: grid;
  place-items: center;
  background: #f7fbff;
}

.platform-figure img {
  width: 100%;
  aspect-ratio: 1 / 0.66;
  object-fit: cover;
}

.platform-body {
  display: grid;
  gap: 12px;
  padding: 22px;
}

.platform-body h3 {
  margin: 0;
  font-size: 22px;
  line-height: 1.25;
}

.platform-body p {
  min-height: 52px;
  margin: 0;
  color: var(--muted);
}

.platform-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--blue);
  font-weight: 800;
}

@media (max-width: 1040px) {
  .platform-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 680px) {
  .platform-grid {
    grid-template-columns: 1fr;
  }

  .platform-body {
    padding: 18px;
  }

  .platform-body h3 {
    font-size: 20px;
  }

  .platform-body p {
    min-height: auto;
    font-size: 14px;
  }
}
</style>
